import {
    deleteInvoiceProviderLoading,
    deleteInvoiceProviderRequest,
    deleteInvoiceProviderSuccess,
    deleteInvoiceProviderReject,
    deleteInvoiceProviderReset
} from "../../actions/invoiceProvider/delete";

export const deleteInvoiceProvider = (formData) => async (dispatch, getState) => {
    try {
        dispatch(deleteInvoiceProviderLoading());
        const { data } = await deleteInvoiceProviderRequest(getState, formData);
        dispatch(deleteInvoiceProviderSuccess(data))
    } catch (error) {
        dispatch(deleteInvoiceProviderReject(error))
    } finally {
        setTimeout(() => { dispatch(deleteInvoiceProviderReset()) }, 3000);
    }
    return Promise.resolve();
};